import styled from '../../theme'

const Divider = styled.div`
  width: 2px;
  height: 25px;
  opacity: 0.3;
  border: 1px solid white;
`

export default Divider
